type PalletLike = { id?: number | string | null } & Record<string, unknown>;

/**
 * The pallet created by /projects/generatePallet. The Java service returns it under "pallets";
 * the earlier Node service used "pallet". Returns null rather than a pallet without an id.
 */
export const createdPalletFromResponse = <T = any>(response: any): T | null => {
  const pallet = response?.pallet ?? response?.pallets;
  const created = Array.isArray(pallet) ? pallet[0] : pallet;
  return created && created.id != null ? created : null;
};

/**
 * The pallet that should become active, or null when the current one is valid. An active pallet
 * that is not in this project's list (missing id, or left over from another project) is replaced,
 * so saves are never sent for a pallet that does not belong here.
 */
export const resolveActivePallet = <T extends PalletLike>(activePallet: PalletLike | null | undefined, pallets: T[]): T | null => {
  if (pallets.length === 0) return null;
  const isListed = activePallet?.id != null && pallets.some((pallet) => pallet.id === activePallet.id);
  return isListed ? null : pallets[0];
};
